(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[622],{

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 2565:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doc/kyc",
      function () {
        return __webpack_require__(4935);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ PolicyContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(1953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(6336);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/common/PolicyContainer/PolicyContainer.module.scss
var PolicyContainer_module = __webpack_require__(2471);
var PolicyContainer_module_default = /*#__PURE__*/__webpack_require__.n(PolicyContainer_module);
;// CONCATENATED MODULE: ./src/components/common/PolicyContainer/PolicyContainer.tsx





var PolicyContainer = function(props) {
    var className = props.className, children = props.children;
    var handleCopy = (0,react.useCallback)(function(e) {
        e.preventDefault();
    }, []);
    (0,react.useLayoutEffect)(function() {
        var listener = function(e) {
            e.preventDefault();
        };
        window.addEventListener("contextmenu", listener);
        return function() {
            return window.removeEventListener("contextmenu", listener);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: classnames_default()((PolicyContainer_module_default()).textWrapper, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            sx: {
                margin: "56px auto"
            },
            onCopy: handleCopy,
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./src/components/common/PolicyContainer/index.ts



/***/ }),

/***/ 4935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ kyc; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(3683);
// EXTERNAL MODULE: ./src/components/common/PolicyContainer/index.ts + 1 modules
var PolicyContainer = __webpack_require__(2402);
// EXTERNAL MODULE: ./src/components/KYC/KYC.module.scss
var KYC_module = __webpack_require__(9319);
var KYC_module_default = /*#__PURE__*/__webpack_require__.n(KYC_module);
;// CONCATENATED MODULE: ./src/components/KYC/KYC.tsx




var KYC = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PolicyContainer/* PolicyContainer */.b, {
        className: (KYC_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: t("footer.links.kyc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "LEAD GATES LTD,"
                    }),
                    " a Company incorporated under the law of Republic of Bulgaria, with the company number 207064979, having its registered office address Apt. 20, Fl. 6, 14 Miziya Str., Town of Plovdiv (hereinafter – \xabSMART GATES\xbb, \xabWe\xbb, \xabOur\xbb, \xabCompany\xbb) is committed to the highest in preventing criminal activities and determining the level of risk for each of our clients (collectively referred to as \xabKnow Your Customer\xbb or \xabKYC\xbb hereinafter - the Policy)."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Objectives"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "In accordance with national and international KYC standards, SMART GATES strictly adheres to the principle of good faith. While we respect the rights of our clients to privacy, we are obligated to exercise special care in collecting information about their identity and the activities they engage in. The SMART GATES policy aims to reduce the level of risk when interacting with our clients by collecting and analyzing their personal information, in compliance with all applicable requirements according to the current legislation worldwide and its subsidiary acts. The policy is based on the principles of good faith partnership: if we know and trust our clients, they, in turn, know us and trust us. We strive not only to obtain evidence confirming and verifying the identity of potential clients and their current plans and objectives but also to ensure that their activities are legal and do not violate international rules and laws."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Interaction with Clients"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "Proper Customer Due Diligence (CDD) is one of the international standards for preventing illegal activities. According to CDD, SMART GATES establishes its own verification procedures within this Policy. Therefore, all clients, in accordance with the Policy, must provide documents according to the list specified below:",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    textDecoration: "underline",
                                    fontStyle: "italic"
                                },
                                children: "Requirements for individuals:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "High-resolution copies of passport pages with a photograph, full name, nationality, date and place of birth, passport issuance and expiration dates, passport number, issuing country, and signature, or copies of ID cards/driver's licenses containing all the aforementioned information;"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Utility bill (e.g., electricity, phone, etc.) or bank statement indicating the date (not older than the past three months), registered name, permanent address, and mailing address;"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "High-resolution copy of the credit card, in case the client uses it to fund the account."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    textDecoration: "underline",
                                    fontStyle: "italic"
                                },
                                children: "Requirements for organizations:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "High-resolution copy of the company registration certificate;"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Copy of the memorandum and articles of association of the organization;"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Certificate of authority indicating the names of directors and shareholders (not older than 6 months);"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Document indicating the registered address of the company;"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Copies of passports of all directors and shareholders of the company;"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Addresses of all directors."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "SMART GATES is not authorized and not obligated to determine whether the document provided by the client for identification is legal. However, in case of obvious discrepancies in the obtained information, SMART GATES reserves the right to request additional identification documents from the client. If the client refuses to provide the required information when necessary or attempts to mislead SMART GATES, the service may be denied to that client."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "SMART GATES reserves the right to periodically verify the client's identity, especially if the client has changed personal details or if their activities seem suspicious (uncharacteristic for a specific client). Additionally, SMART GATES reserves the right to request updated documents from clients, even if they have previously undergone verification."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Frequency"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "In order to ensure the accuracy of client data, SMART GATES, at its discretion and with individually established periodicity, has the right to request any information and documents from its clients. In this regard, if a client wishes to continue using SMART GATES services, they cannot refuse to provide the requested information."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Disclaimer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "At any time during the provision of services, SMART GATES has the right, at its discretion and based on this Policy, to request documents from the client (a list determined solely by SMART GATES, including the form of the documents to be provided) to confirm any actions (or transactions) already carried out by the client or intended to be carried out by the client. At the same time, SMART GATES reserves the exclusive right to unilaterally reject the client's application and/or terminate further service provision without providing any explanation for the reasons."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Final Provisions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "SMART GATES may disclaim potential legal liability in a situation where the provided services and/or products are used by the client for illegal activities."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "If we identify signs of suspicious activity by a client that may be associated with illegal activities, information about it will be reported to the competent authorities."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "If you have any questions regarding this Policy, please contact us via the available communication channels or by e-mail ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "support@smart-gates.net."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "SMART GATES reserves the right to change and/or supplement this Policy unilaterally without notifying the Client."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "In case of any discrepancies between different forms (print, electronic, etc.) and/or revision dates of this Policy, the official and effective version posted on the official information resources of SMART GATES shall prevail."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                style: {
                    marginTop: "100px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Publication date:"
                    }),
                    " 05/29/2023"
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/KYC/index.ts


;// CONCATENATED MODULE: ./src/pages/doc/kyc.tsx


var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KYC, {})
    });
};
var __N_SSG = true;
/* harmony default export */ var kyc = (Page);


/***/ }),

/***/ 9319:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"KYC_root__oJy4j"};

/***/ }),

/***/ 2471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"PolicyContainer_textWrapper__a77cv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2565); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);